import LoadingState from '../../../values/loading-state-enum'
import {type LocationIdType} from '../locations/state'
import {SortDirection} from '../my-vessels-filters/types/my-vessel-filter-state'
import {type SortValue} from '../vessel-filter/types/vessel-filter-state'
import {
    DeviceStatus,
    USBDevicesSortType,
    type UsbDeviceType,
} from '../../../api/usb/types/usb.types'

export interface UsbInventoryFilterReduxState {
    loadingState: LoadingState
    searchedFirstDetected: TimestampFilter
    searchedLastActive: TimestampFilter
    searchedVendor: string | undefined
    searchedProductName: string | undefined
    searchedType: USBDeviceType[]
    searchedHostnames: string | undefined
    hasPurpose: boolean | undefined
    locations: Set<LocationIdType> | undefined
    sortColumn: SortColumnType
    selectedUsbDeviceStatus: DeviceStatus[] | undefined
    searchVesselTagTerm: string[]
    searchVesselNameTerm: string
    searchedVesselTerm: string
    showXButton: boolean
    vesselSort: SortValue
    selectedFilterName: string
    filterExpanded: FilterExpandedType
    detailExpanded: DetailExpandedType
}

export interface SortColumnType {
    orderBy: USBDevicesSortType
    orderAscending: boolean
}

// Re-exported from usb.types.ts - this is the canonical source of truth
export {DeviceStatus}

// Re-exported from usb.types.ts - this is the canonical source of truth
export type USBDeviceType = UsbDeviceType
export {USBDevicesSortType}

export type TimestampFilter = 'Last 24h' | 'Last 7 days' | 'Last 30 days' | 'All'
export interface DetailExpandedType {
    detailsExpanded: boolean
    insightsExpanded: boolean
    actionsExpanded: boolean
    usbHistoryExpanded: boolean
}

export enum UsbDevicesDetailType {
    Details = 'Details',
    Insights = 'Insights',
    Actions = 'Actions',
    USBHistory = 'History',
}
export interface FilterExpandedType {
    deviceStatus: boolean
    vesselExpanded: boolean
}

export enum FilterBarType {
    UsbDeviceStatus = 'USB device status',
    Vessels = 'Vessels',
}

export const DEFAULT_USB_INVENTORY_FILTER_STATE: UsbInventoryFilterReduxState = {
    loadingState: LoadingState.NotPopulated,
    searchedFirstDetected: 'All',
    searchedLastActive: 'All',
    searchedVendor: '',
    searchedProductName: '',
    searchedType: ['storage', 'other'],
    searchedHostnames: '',
    locations: undefined,
    sortColumn: {
        orderBy: USBDevicesSortType.TIMESTAMP,
        orderAscending: false,
    },
    selectedUsbDeviceStatus: undefined,
    searchVesselTagTerm: [],
    searchVesselNameTerm: '',
    searchedVesselTerm: '',
    hasPurpose: undefined,
    showXButton: false,
    vesselSort: {
        field: 'vessel-name',
        direction: SortDirection.DESC,
    },
    selectedFilterName: 'Saved filters',
    filterExpanded: {deviceStatus: true, vesselExpanded: true},
    detailExpanded: {
        detailsExpanded: true,
        insightsExpanded: true,
        actionsExpanded: true,
        usbHistoryExpanded: true,
    },
}
